/* eslint-disable jsx-a11y/anchor-is-valid */
import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import {
  admin,
  useGetSeasonalStoreBasicDataQuery,
  useGetSeasonalStoreTimeingListDataQuery,
  useUpdateSeasonalStoreTimeingStatusMutation,
  useUpdateSeasonalStoreTimeingTableHeadDataMutation,
} from "../../../store/queries/Admin";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteStore } from "./AddSeasonalStore/api";
import { current } from "@reduxjs/toolkit";
import { getSeasonalStoreEditData } from "./api";

const useSeasonalStoreTimeingStore = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const { data: basicData = {}, isLoading: basicLoading } =
    useGetSeasonalStoreBasicDataQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuFetching, setMenuFetching] = useState(false);
  const [isDeleteing, setIsDeleteing] = useState(false);
  const { showEditModal } = useSelector((state) => state.global);
  const [storeState, setStoreState] = useState({
    currentPage: 1,
    currentFilter: "all",
    currentPageSize: 10,
    sortBy: "",
    sortOrder: "",
    search: "",
    selectedId: "",
    endDate: "",
    startDate: "",
    status: "",
    createFilterModal: false,
    showCreateModal: false,
    showDeleteModal: false,
    isDuplicate:false,
    isEdit: false,
    itemData: {},
    activeTab: "Basic",
    imageName: "",
    curbTimeError: {},
    pickupTimeError: {},
    clearSelection: false,
  });
  const {
    data: storeList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetSeasonalStoreTimeingListDataQuery({
    page_size: storeState?.currentPageSize,
    page: storeState?.currentPage,
    sort: storeState?.sortBy,
    sort_order: storeState?.sortOrder,
    search: storeState?.search,
  });
  const [updateSeasonalStoreTimeingTableHeadData] =
    useUpdateSeasonalStoreTimeingTableHeadDataMutation();
  const [updateSeasonalStoreTimeingStatus] =
    useUpdateSeasonalStoreTimeingStatusMutation();

  const handleCreateClick = () => {
    setStoreState((prev) => ({
      ...prev,
      showCreateModal: !prev.showCreateModal,
      currentPageSize: 10,
      currentPage: 1,
      isEdit: false,
      activeTab: "Basic",
      imageName: "",
      curbTimeError: {},
      pickupTimeError: {},
      itemData: {},
      isDuplicate:false,
    }));
  };
  useEffect(() => {
    if (storeState.clearSelection) {
      setStoreState((prev) => ({
        ...prev,
        clearSelection: false,
      }));
    }
    // eslint-disable-next-line
  }, [storeState.clearSelection]);

  const handleSearch = (e) => {
    setStoreState((prev) => ({
      ...prev,
      search: e.target.value,
      currentPage: 1,
    }));
  };
  const handleClearClick = () => {
    setStoreState((prev) => ({
      ...prev,
      search: "",
      currentPage: 1,
    }));
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      }),
    );
  };
  const handleToggle = (e, data) => {
    const newStatus = data.status === 1 ? false : true;
    let body = {
      id: data?._id,
      status: newStatus ? 1 : 2,
    };
    updateSeasonalStoreTimeingStatus(body);
    dispatch(
      admin.util.updateQueryData(
        "getSeasonalStoreTimeingListData",
        {
          page_size: storeState?.currentPageSize,
          page: storeState?.currentPage,
          sort: storeState?.sortBy,
          sort_order: storeState?.sortOrder,
          search: storeState?.search,
        },
        (cacheEntry) => {
          let currentCache = { ...current(cacheEntry) };
          const newResult = currentCache.result?.map((res) =>
            res._id === data?._id
              ? {
                  ...res,
                  status: data.status === 1 ? 2 : 1,
                }
              : res,
          );
          currentCache = {
            ...currentCache,
            result: newResult,
          };
          return currentCache;
        },
      ),
    );
  };
  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className={`pro-mb-0 `}>{data[field]}</p>,
      status: (field, data) => {
        const isChecked = data?.status === 1;
        return (
          <div
          // className={`${
          //   data?.menu_updation === 1 ? Style.product_active : ""
          // }`}
          >
            <div className="form-check form-switch ">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                checked={isChecked}
                onChange={(e) => handleToggle(e, data)}
                disabled={!storeList?.edit_permission}
              />
            </div>
          </div>
        );
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleSort = (label) => {
    if (storeState.sortBy === label) {
      setStoreState((prev) => ({
        ...prev,
        currentPage: 1,
        sortBy: label,
        sortOrder: storeState.sortOrder === "asc" ? "desc" : "asc",
      }));
    } else {
      setStoreState((prev) => ({
        ...prev,
        currentPage: 1,
        sortBy: label,
        sortOrder: "asc",
      }));
    }
  };
  const handleEditAction = (e) => {
    getSeasonalStoreEditData(e?.[0]).then((response) => {
      if (response?.data?.status_code === 200) {
        setStoreState((prev) => ({
          ...prev,
          itemData: response?.data?.data,
          showCreateModal: true,
          selectedId: e?.[0],
          isEdit: true,
          isDuplicate: false,
        }));
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  const handleDeleteModal = (e) => {
    setStoreState((prev) => ({
      ...prev,
      showDeleteModal: !prev.showDeleteModal,
      selectedId: e?.[0],
    }));
  };
  const handlePagination = (page) => {
    setStoreState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };
  const handlePageSize = ({ value: page_size }) => {
    setStoreState((prev) => ({
      ...prev,
      currentPageSize: page_size,
      currentPage: 1,
    }));
  };
  const handleDelete = async () => {
    setIsDeleteing(true);
    const response = await deleteStore(storeState?.selectedId);
    if (response && response.status === 200) {
      toast.success(`Seasonal Store Timing Deleted successfully.`);
      setStoreState((prev) => ({
        ...prev,
        currentPage: 1,
        search: "",
      }));
      setTimeout(() => {
        refetch();
      }, 0);
      setIsDeleteing(false);
    } else {
      toast.error(`Something went wrong !`);
      setIsDeleteing(false);
    }
    handleDeleteModal();
    setStoreState((prev) => ({
      ...prev,
      clearSelection: false,
    }));
  };
  const handleDuplicateClick = (e) => {
    getSeasonalStoreEditData(e?.[0]).then((response) => {
      if (response?.data?.status_code === 200) {
        setStoreState((prev) => ({
          ...prev,
          itemData: response?.data?.data,
          showCreateModal: true,
          selectedId: e?.[0],
          isEdit: false,
          isDuplicate: true,
        }));
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  return {
    isLoading,
    isFetching,
    storeList,
    showEditModal,
    menuFetching,
    storeState,
    paginationOptions,
    basicData,
    isDeleteing,
    handleDuplicateClick,
    setStoreState,
    handleEditColumnsClick,
    updateSeasonalStoreTimeingTableHeadData,
    handleDeleteModal,
    handleCreateClick,
    handleEditAction,
    handleClearClick,
    handlePagination,
    handlePageSize,
    handleSearch,
    handleDelete,
    handleSort,
    refetch,
    getRow,
  };
};

export default useSeasonalStoreTimeingStore;
